import i18n from '../../../../../config/i18n/i18n';
import { market } from '../../../../../constants';
import { returnProvidenceIdByCountry } from '../../../../../helpers/addresses/AddressesHelper';

const getAddressOrProfileValueByField = (address, profile, field) => {
  if (address) return address[field] || '';
  return !profile?.addressLine && profile[field] ? profile[field] : '';
};

const getPhoneByMarket = (address, profile) => {
  switch (market) {
    case 'pe':
      return getAddressOrProfileValueByField(address, profile, 'phone1');
    case 'cl':
      if (address?.phone1) return `${address.fax1}${address.phone1}`;
      if (address?.mobilePhone1) return `9${address.mobilePhone1}`;
      return '';
    default:
      return '';
  }
};

export const makeInitialState = (address, profile, regions) => {
  return {
    addressName: {
      value: address
        ? address.nickName
        : !profile.addressLine
        ? 'Dirección Inicial'
        : '',
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Nombre de la dirección',
    },
    name: {
      value: getAddressOrProfileValueByField(address, profile, 'firstName'),
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Nombre',
    },
    lastname: {
      value: getAddressOrProfileValueByField(address, profile, 'lastName'),
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Apellidos',
    },
    phone: {
      value: getPhoneByMarket(address, profile),
      error: false,
      message: '',
      helper: 'Ingresar 9 dígitos',
      inputAdornment: i18n.t('profile.phoneAdornment'),
      label: 'Telefono',
    },
    street: {
      value: address?.addressLine ? address.addressLine[0] : '',
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Dirección',
    },
    ...(market === 'cl' && {
      number: {
        value: address?.addressLine ? address.addressLine[1] : '',
        error: false,
        message: '',
        helper: '',
        inputAdornment: '',
        label: 'Número',
      },
      houseType: {
        value: address?.addressLine ? address.addressLine[2] : '',
        error: false,
        message: '',
        helper: '',
        inputAdornment: '',
        label: 'Dpto/Oficina/Casa',
      },
    }),
    level1: {
      value: address ? address.state : '',
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: i18n.t('localities.level1'),
    },
    level2: {
      value: address ? returnProvidenceIdByCountry(address, regions) : '',
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: i18n.t('localities.level2'),
    },
    ...(market === 'pe' && {
      level3: {
        value: address ? address.city : '',
        error: false,
        message: '',
        helper: '',
        inputAdornment: '',
        label: i18n.t('localities.level3'),
      },
    }),
  };
};
